import Component from '../core/Component'
import { substitute } from '../utils/String'
import { toggleClass } from '../utils/dom'

export const STATES = {
    FILES: 'has-files'
}

export default class InputUpload extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            inner: null,
            list: null,
            itemTemplate: null,
            fileTemplate: null
        }

        this.fileNames = []
        this.counter = 0

        this.rules = ''
        this.maxValue =  ''
		this.netteError = 'Maximální velikost souboru je 15 MB.'
    }

    prepare() {
        this.itemTemplate = this.ref.itemTemplate.textContent.trim()
        this.fileTemplate = this.ref.fileTemplate.textContent.trim()
        this.element.addEventListener('change', this.handleChange)

        this.rules = this.ref.inner.querySelector('input')?.dataset?.netteRules || ''
        this.maxValue = this.element.dataset?.maxvalue
    }

    handleChange = event => {
        this.appendInputToList(event.target)
    }

    createNewInput() {
        const div = document.createElement('div')
        div.innerHTML = substitute(this.fileTemplate, {id: `file-${this.fileNames.length}`})

        this.ref.inner.prepend(div.firstChild)
    }

    removeItemFromList(element) {
        this.counter--
        element.parentNode.removeChild(element)
        this.check()
    }

    appendInputToList(input) {
        const errorContainer = this.element.closest('.u-errorContainer')
        const files = [...input.files]

        if (files.length < 1) {
			const input = this.ref.inner.querySelector('input')
            if (input) {
                input.dataset.netteRules = this.rules
            }
            return
        }
        const fileName = files[0].name

        const fileToMB = parseFloat(files[0].size) / (1024 ** 2)
        const maxFileValue = fileToMB.toFixed(2) >= parseFloat(this.maxValue)

        if (this.maxValue && maxFileValue) {
            this.fileNames = []
            let errorElement = errorContainer.querySelector('.InputError');

            if (!errorElement) {
                errorElement = document.createElement('div');
                errorElement.className = 'InputError';
            }

			errorElement.innerHTML = this.netteError
            errorContainer.appendChild(errorElement);
            errorContainer.classList.add('has-error');
            errorElement.classList.remove('is-valid');
        } else {
            if (!maxFileValue) {
                errorContainer.classList.remove('has-error');
                errorContainer.classList.remove('is-invalid');

                let errorElement = errorContainer.querySelector('.InputError');
                if (errorElement && !maxFileValue) {
                    errorElement.remove()
                }

				const itemElement = document.createElement('div')
				itemElement.classList.add('InputUpload-item')

				itemElement.innerHTML = substitute(this.itemTemplate, { fileName })

				input.tabIndex = '-1'
				input.removeAttribute('data-nette-rules')
				itemElement.prepend(input)
				itemElement.querySelector('[data-ref="buttonRemove"]').addEventListener('click', () => this.removeItemFromList(itemElement))

				this.ref.list.appendChild(itemElement)
				this.fileNames.push(fileName)
				this.counter++
				this.check()

				this.createNewInput()
            }
        }
    }

    check() {
        if (this.counter === 0) {
            const input = this.ref.inner.querySelector('input')

            if (input) {
                input.dataset.netteRules = this.rules
            }
        }
        toggleClass(this.element, STATES.FILES, this.counter > 0)
    }
}
